export const SCRIPT_PATHS = {
  web: '/vymoWeb/index.js',
  selfserve: '/selfserve/index.js',
} as const;

export const CLIENT_CONFIGS = {
  web: {
    appEnv: process.env.DEPLOY_ENV,
    moduleProps: {
      isLoggedIn: () => true,
      isPortalLoggedIn: () => true,
      showSideHamBurgerMenu: () => {},
    },
  },
  selfserve: {
    appEnv: process.env.DEPLOY_ENV,
    moduleProps: {
      isLoggedIn: () => true,
      isPortalLoggedIn: () => true,
    },
  },
} as const;
